<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <form>
        <v-card-text>
          <v-container class="d-flex flex-column align-center">
            <p
              class="mb-6"
              style="font-weight: 500; font-size: 16px; text-align: center"
              v-html="mess['dialog_accept_file_description_top']"
            ></p>
            <div
              style="display: flex; width: 350px; min-height: 125px"
              class="mb-6"
            >
              <img
                src="/assets/img/dialog-accept-file-img.png"
                style="max-width: 100%; height: auto"
                alt="#"
              />
            </div>
            <p
              class="mb-2"
              style="font-weight: 500; font-size: 16px; text-align: center"
              v-html="mess['dialog_accept_file_description_bottom']"
            ></p>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px" class="justify-center">
          <v-btn
            style="min-width: 170px"
            color="primary"
            outlined
            depressed
            dark
            @click="close"
            >{{ mess["dialog_accept_file_cancel_button"] }}</v-btn
          >
          <v-btn
            style="min-width: 170px"
            color="primary"
            depressed
            dark
            type="button"
            @click="search"
            >{{ mess["dialog_accept_file_accept_button"] }}</v-btn
          >
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CreateLeadAcceptFile",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    search() {
      this.$emit("search");
      this.dialog = false;
    },
    close() {
      this.$emit("clear-file");
      this.dialog = false;
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      if (!val) this.$emit("clear-file");
      this.$emit("update:is-visible", val);
    }
  }
};
</script>

<style lang="scss"></style>
